/*
    Bot bubble
*/

// Fill Color Selector
var select = document.getElementById('chat-bubble-bot-color-selector');
var colorPreview = document.getElementById('color-preview-chat-bubble-bot');
var botBubbles = document.getElementsByClassName('regular-message bot');

window.updateBotBubbleColor = function () {
    select.replaceChildren();
    var option = document.createElement('option');
    option.value = "";
    option.text = "No Color";
    select.appendChild(option);

    colorPreview.style.backgroundColor = "transparent";
    colorPreview.style.border = "#5D5D5D 1px solid";
        
    for (const val of window.colors.colors) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        select.appendChild(option);
    }
}
select.addEventListener('change', function(event) {
    for (const val of window.colors.colors) {
        if (val.settings.name == event.target.value) {
            colorPreview.style.backgroundColor = val.settings.color;
            window.customStyle[".regular-message.bot"]["background"] = val.settings.color + " !important";
            window.customStyle[".BorderBubble"]["background"] = val.settings.color + " !important";
            window.customStyle[".MessengerText"]["background"] = val.settings.color + " !important";
            window.customStyle[".webchat-typing-indicator"]["background"] = val.settings.color + " !important";
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }
    if (event.target.value == "") {
        console.log("NO COLOR");
        colorPreview.style.backgroundColor = "transparent !important";
        console.log(colorPreview);
        colorPreview.style.border = "#5D5D5D 1px solid";
        window.customStyle['.regular-message.bot']['background'] = "transparent !important";
        window.customStyle['.BorderBubble']['background'] = "transparent !important";
        window.customStyle[".MessengerText"]["background"] = "transparent !important";
        window.customStyle[".webchat-typing-indicator"]["background"] = "transparent !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        console.log("COLOR");
        colorPreview.style.border = "transparent !important";
    }
})

// Text Color Selector
var selectText = document.getElementById('chat-bubble-bot-text-color-selector');
var colorPreviewText = document.getElementById('color-text-preview-chat-bubble-bot');
window.updateBotBubbleTextColor = function () {
    selectText.replaceChildren();

    var option = document.createElement('option');
    option.value = "";
    option.text = "No Color";
    selectText.appendChild(option);

    colorPreviewText.style.backgroundColor = "transparent";
    colorPreviewText.style.border = "#5D5D5D 1px solid";

    for (const val of window.colors.colors) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        selectText.appendChild(option);
    }
}
selectText.addEventListener('change', function(event) {
    for (const val of window.colors.colors) {
        if (val.settings.name == event.target.value) {
            colorPreviewText.style.backgroundColor = val.settings.color;
            window.customStyle[".regular-message.bot"]["color"] = val.settings.color + " !important";
            window.customStyle[".BorderBubble"]["color"] = val.settings.color + " !important";
            window.customStyle[".MessengerText"]["color"] = val.settings.color + " !important";
            window.customStyle[".webchat-typing-indicator"]["color"] = val.settings.color + " !important";
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }
    if (event.target.value == "") {
        colorPreviewText.style.backgroundColor = "transparent !important";
        colorPreviewText.style.border = "#5D5D5D 1px solid";
        window.customStyle['.regular-message.bot']['color'] = "transparent !important";
        window.customStyle['.BorderBubble']['color'] = "transparent !important";
        window.customStyle['.MessengerText']['color'] = "transparent !important";
        window.customStyle['.webchat-typing-indicator']['color'] = "transparent !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        colorPreviewText.style.border = "transparent !important";
    }
})

// Font Style
var selectFont = document.getElementById("chat-bubble-bot-font");
window.updateBotBubbleFonts = function() {
    selectFont.replaceChildren();
    
    var option = document.createElement('option');
    option.value = "";
    option.text = "No Fonts";
    selectFont.appendChild(option);
    
    for (const val of window.fonts.fonts) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        option.setAttribute("data-id", val.id);
        selectFont.appendChild(option);
    }
}
selectFont.addEventListener("change", function(event) {
    for (const val of window.fonts.fonts) {
        if (val.settings.name == event.target.value) {
            selectFont.style.color = val.settings.color;
            selectFont.style.fontFamily = val.settings.fontFamily;
            selectFont.style.fontSize = val.settings.size;

            window.customStyle[".regular-message.bot"]["font-family"] = val.settings.fontFamily + " !important";
            window.customStyle[".regular-message.bot"]["font-size"] = val.settings.size + " !important";
            window.customStyle[".regular-message.bot"]["color"] = val.settings.color + " !important";
            window.customStyle[".BorderBubble"]["font-family"] = val.settings.fontFamily + " !important";
            window.customStyle[".BorderBubble"]["font-size"] = val.settings.size + " !important";
            window.customStyle[".BorderBubble"]["color"] = val.settings.color + " !important";
            window.customStyle[".MessengerText"]["font-family"] = val.settings.fontFamily + " !important";
            window.customStyle[".MessengerText"]["font-size"] = val.settings.size + " !important";
            window.customStyle[".MessengerText"]["color"] = val.settings.color + " !important";
            window.customStyle[".webchat-typing-indicator"]["font-family"] = val.settings.fontFamily + " !important";
            window.customStyle[".webchat-typing-indicator"]["font-size"] = val.settings.size + " !important";
            window.customStyle[".webchat-typing-indicator"]["color"] = val.settings.color + " !important";
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }
})

// Corner Radius
var cornerRadiusTopL = document.getElementById('corner-radius-topL-chat-bubble-bot');
cornerRadiusTopL.addEventListener('change', function(event) {
    window.customStyle[".regular-message.bot"]["border-top-left-radius"] = event.target.value + " !important";
    window.customStyle[".BorderBubble"]["border-top-left-radius"] = event.target.value + " !important";
    window.customStyle[".MessengerText"]["border-top-left-radius"] = event.target.value + " !important";
    window.customStyle[".webchat-typing-indicator"]["border-top-left-radius"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var cornerRadiusTopR = document.getElementById('corner-radius-topR-chat-bubble-bot');
cornerRadiusTopR.addEventListener('change', function(event) {
    window.customStyle[".regular-message.bot"]["border-top-right-radius"] = event.target.value + " !important";
    window.customStyle[".BorderBubble"]["border-top-right-radius"] = event.target.value + " !important";
    window.customStyle[".MessengerText"]["border-top-right-radius"] = event.target.value + " !important";
    window.customStyle[".webchat-typing-indicator"]["border-top-right-radius"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var cornerRadiusBottomR = document.getElementById('corner-radius-bottomR-chat-bubble-bot');
cornerRadiusBottomR.addEventListener('change', function(event) {
    window.customStyle[".regular-message.bot"]["border-bottom-right-radius"] = event.target.value + " !important";
    window.customStyle[".BorderBubble"]["border-bottom-right-radius"] = event.target.value + " !important";
    window.customStyle[".MessengerText"]["border-bottom-right-radius"] = event.target.value + " !important";
    window.customStyle[".webchat-typing-indicator"]["border-bottom-right-radius"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var cornerRadiusBottomL = document.getElementById('corner-radius-bottomL-chat-bubble-bot');
cornerRadiusBottomL.addEventListener('change', function(event) {
    window.customStyle[".regular-message.bot"]["border-bottom-left-radius"] = event.target.value + " !important";
    window.customStyle[".BorderBubble"]["border-bottom-left-radius"] = event.target.value + " !important";
    window.customStyle[".MessengerText"]["border-bottom-left-radius"] = event.target.value + " !important";
    window.customStyle[".webchat-typing-indicator"]["border-bottom-left-radius"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

// Padding
var paddingTop = document.getElementById('padding-top-chat-bubble-bot');
paddingTop.addEventListener('change', function(event){
    window.customStyle[".regular-message.bot"]["padding-top"] = event.target.value + " !important";
    window.customStyle[".BorderBubble"]["padding-top"] = event.target.value + " !important";
    window.customStyle[".MessengerText"]["padding-top"] = event.target.value + " !important";
    window.customStyle[".webchat-typing-indicator"]["padding-top"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var paddingBottom = document.getElementById('padding-bottom-chat-bubble-bot');
paddingBottom.addEventListener('change', function(event){
    window.customStyle[".regular-message.bot"]["padding-bottom"] = event.target.value + " !important";
    window.customStyle[".BorderBubble"]["padding-bottom"] = event.target.value + " !important";
    window.customStyle[".MessengerText"]["padding-bottom"] = event.target.value + " !important";
    window.customStyle[".webchat-typing-indicator"]["padding-bottom"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var paddingLeft = document.getElementById('padding-left-chat-bubble-bot');
paddingLeft.addEventListener('change', function(event){
    window.customStyle[".regular-message.bot"]["padding-left"] = event.target.value + " !important";
    window.customStyle[".BorderBubble"]["padding-left"] = event.target.value + " !important";
    window.customStyle[".MessengerText"]["padding-left"] = event.target.value + " !important";
    window.customStyle[".webchat-typing-indicator"]["padding-left"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var paddingRight = document.getElementById('padding-right-chat-bubble-bot');
paddingRight.addEventListener('change', function(event){
    window.customStyle[".regular-message.bot"]["padding-right"] = event.target.value + " !important";
    window.customStyle[".BorderBubble"]["padding-right"] = event.target.value + " !important";
    window.customStyle[".MessengerText"]["padding-right"] = event.target.value + " !important";
    window.customStyle[".webchat-typing-indicator"]["padding-right"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

// Margin
var marginTop = document.getElementById('margin-top-chat-bubble-bot');
marginTop.addEventListener('change', function(event){
    window.customStyle[".regular-message.bot"]["margin-top"] = event.target.value + " !important";
    window.customStyle[".BorderBubble"]["margin-top"] = event.target.value + " !important";
    window.customStyle[".MessengerText"]["margin-top"] = event.target.value + " !important";
    window.customStyle[".webchat-typing-indicator"]["margin-top"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var marginBottom = document.getElementById('margin-bottom-chat-bubble-bot');
marginBottom.addEventListener('change', function(event){
    window.customStyle[".regular-message.bot"]["margin-bottom"] = event.target.value + " !important";
    window.customStyle[".BorderBubble"]["margin-bottom"] = event.target.value + " !important";
    window.customStyle[".MessengerText"]["margin-bottom"] = event.target.value + " !important";
    window.customStyle[".webchat-typing-indicator"]["margin-bottom"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var marginLeft = document.getElementById('margin-left-chat-bubble-bot');
marginLeft.addEventListener('change', function(event){
    window.customStyle[".regular-message.bot"]["margin-left"] = event.target.value + " !important";
    window.customStyle[".BorderBubble"]["margin-left"] = event.target.value + " !important";
    window.customStyle[".MessengerText"]["margin-left"] = event.target.value + " !important";
    window.customStyle[".webchat-typing-indicator"]["margin-left"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var marginRight = document.getElementById('margin-right-chat-bubble-bot');
marginRight.addEventListener('change', function(event){
    window.customStyle[".regular-message.bot"]["margin-right"] = event.target.value + " !important";
    window.customStyle[".BorderBubble"]["margin-right"] = event.target.value + " !important";
    window.customStyle[".MessengerText"]["margin-right"] = event.target.value + " !important";
    window.customStyle[".webchat-typing-indicator"]["margin-right"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

// Border
var borderColor = "black";
var borderWidth = "1px";
var borderString = borderWidth + " solid " + borderColor;

var selectBorderPos = document.getElementById('chat-bubble-bot-border-selector');
selectBorderPos.addEventListener('change', function(event) {
    if (event.target.value == "inside") {
        window.customStyle[".regular-message.bot"]["box-sizing"] = "border-box !important";
        window.customStyle[".BorderBubble"]["box-sizing"] = "border-box !important";
        window.customStyle[".MessengerText"]["box-sizing"] = "border-box !important";
        window.customStyle[".webchat-typing-indicator"]["box-sizing"] = "border-box !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        window.customStyle[".regular-message.bot"]["box-sizing"] = "content-box !important";
        window.customStyle[".BorderBubble"]["box-sizing"] = "content-box !important";
        window.customStyle[".MessengerText"]["box-sizing"] = "content-box !important";
        window.customStyle[".webchat-typing-indicator"]["box-sizing"] = "content-box !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    }
})

var selectBorder = document.getElementById('chat-bubble-bot-border-color-selector');
var colorPreviewBorder = document.getElementById('color-border-preview-chat-bubble-bot');
window.updateBotBubbleBorderColor = function() {
    selectBorder.replaceChildren();

    var option = document.createElement('option');
    option.value = "";
    option.text = "No Color";
    selectBorder.appendChild(option);

    colorPreviewBorder.style.backgroundColor = "transparent";
    colorPreviewBorder.style.border = "#5D5D5D 1px solid";
    
    for (const val of window.colors.colors) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        selectBorder.appendChild(option);
    }
}
selectBorder.addEventListener('change', function(event) {
    for (const val of window.colors.colors) {
        if (val.settings.name == event.target.value) {
            colorPreviewBorder.style.backgroundColor = val.settings.color;

            borderColor = val.settings.color;
            borderString = borderWidth + " solid " + borderColor;
            window.customStyle[".regular-message.bot"]["border"] = borderString + " !important";
            window.customStyle[".BorderBubble"]["border"] = borderString + " !important";
            window.customStyle[".MessengerText"]["border"] = borderString + " !important";
            window.customStyle[".webchat-typing-indicator"]["border"] = borderString + " !important";
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }
    if (event.target.value == "") {
        colorPreviewBorder.style.backgroundColor = "transparent";
        colorPreviewBorder.style.border = "#5D5D5D 1px solid";
        window.customStyle['.regular-message.bot']['background-color'] = "transparent";
        window.customStyle['.BorderBubble']['background-color'] = "transparent";
        window.customStyle['.MessengerText']['background-color'] = "transparent";
        window.customStyle['.webchat-typing-indicator']['background-color'] = "transparent";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        colorPreviewBorder.style.border = "transparent";
    }
});

var widthBorder = document.getElementById('width-border-chat-bubble-bot');
widthBorder.addEventListener('change', function(event) {
    borderWidth = event.target.value;
    borderString = borderWidth + " solid " + borderColor;
    window.customStyle[".regular-message.bot"]["border"] = borderString + " !important";
    window.customStyle[".BorderBubble"]["border"] = borderString + " !important";
    window.customStyle[".MessengerText"]["border"] = borderString + " !important";
    window.customStyle[".webchat-typing-indicator"]["border"] = borderString + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

// Shadow
var hOffset = "0px";
var vOffset = "0px";
var blurShadow = "0px";
var spreed = "0px";
var shadowColor = "#000";
var shadowPos = "";

var hOffsetElement = document.getElementById("chat-bubble-bot-shadow-h-offset");
hOffsetElement.addEventListener("change", function(event) {

    hOffset = event.target.value;
    var shadow = hOffset + " " + vOffset + " " + blurShadow + " " + spreed + " " + shadowColor + " " + shadowPos + " !important";

    window.customStyle[".regular-message.bot"]["box-shadow"] = shadow;
    window.customStyle[".BorderBubble"]["box-shadow"] = shadow;
    window.customStyle[".MessengerText"]["box-shadow"] = shadow;
    window.customStyle[".webchat-typing-indicator"]["box-shadow"] = shadow;
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var vOffsetElement = document.getElementById("chat-bubble-bot-shadow-v-offset");
vOffsetElement.addEventListener("change", function(event) {

    vOffset = event.target.value;
    var shadow = hOffset + " " + vOffset + " " + blurShadow + " " + spreed + " " + shadowColor + " " + shadowPos + " !important";

    window.customStyle[".regular-message.bot"]["box-shadow"] = shadow;
    window.customStyle[".BorderBubble"]["box-shadow"] = shadow;
    window.customStyle[".MessengerText"]["box-shadow"] = shadow;
    window.customStyle[".webchat-typing-indicator"]["box-shadow"] = shadow;
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var blurElement = document.getElementById("chat-bubble-bot-shadow-blur");
blurElement.addEventListener("change", function(event) {

    blurShadow = event.target.value;
    var shadow = hOffset + " " + vOffset + " " + blurShadow + " " + spreed + " " + shadowColor + " " + shadowPos + " !important";

    window.customStyle[".regular-message.bot"]["box-shadow"] = shadow;
    window.customStyle[".BorderBubble"]["box-shadow"] = shadow;
    window.customStyle[".MessengerText"]["box-shadow"] = shadow;
    window.customStyle[".webchat-typing-indicator"]["box-shadow"] = shadow;
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var spreedElement = document.getElementById("chat-bubble-bot-shadow-spreed");
spreedElement.addEventListener("change", function(event) {

    spreed = event.target.value;
    var shadow = hOffset + " " + vOffset + " " + blurShadow + " " + spreed + " " + shadowColor + " " + shadowPos + " !important";

    window.customStyle[".regular-message.bot"]["box-shadow"] = shadow;
    window.customStyle[".BorderBubble"]["box-shadow"] = shadow;
    window.customStyle[".MessengerText"]["box-shadow"] = shadow;
    window.customStyle[".webchat-typing-indicator"]["box-shadow"] = shadow;
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var selectShadow = document.getElementById('chat-bubble-bot-shadow-color-selector');
var colorPreviewShadow = document.getElementById('color-shadow-preview-color-chat-bubble-bot');
window.updateBotBubbleShadowColor = function() {
    selectShadow.replaceChildren();
    
    var option = document.createElement('option');
    option.value = "";
    option.text = "No Color";
    selectShadow.appendChild(option);

    colorPreviewShadow.style.backgroundColor = "transparent";
    colorPreviewShadow.style.border = "#5D5D5D 1px solid";
        
    for (const val of window.colors.colors) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        selectShadow.appendChild(option);
    }
}
selectShadow.addEventListener('change', function(event) {
    for (const val of window.colors.colors) {
        if (val.settings.name == event.target.value) {
            colorPreviewShadow.style.backgroundColor = val.settings.color;
            shadowColor = val.settings.color;
            var shadow = hOffset + " " + vOffset + " " + blurShadow + " " + spreed + " " + shadowColor + " " + shadowPos + " !important";
            window.customStyle[".regular-message.bot"]["box-shadow"] = shadow;
            window.customStyle[".BorderBubble"]["box-shadow"] = shadow;
            window.customStyle[".MessengerText"]["box-shadow"] = shadow;
            window.customStyle[".webchat-typing-indicator"]["box-shadow"] = shadow;
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }
    if (event.target.value == "") {
        colorPreviewShadow.style.backgroundColor = "transparent";
        colorPreviewShadow.style.border = "#5D5D5D 1px solid";
        window.customStyle['.regular-message.bot']['box-shadow'] = "transparent";
        window.customStyle['.BorderBubble']['box-shadow'] = "transparent";
        window.customStyle['.MessengerText']['box-shadow'] = "transparent";
        window.customStyle['.webchat-typing-indicator']['box-shadow'] = "transparent";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        colorPreview.style.border = "transparent";
    }
});

var shadowPosElement = document.getElementById("chat-bubble-bot-shadow-position");
shadowPosElement.addEventListener("change", function(event) {
    if (event.target.value == "inner") {
        shadowPos = "inset";
    } else {
        shadowPos = "";
    }
    var shadow = hOffset + " " + vOffset + " " + blurShadow + " " + spreed + " " + shadowColor + " " + shadowPos + " !important";

    window.customStyle[".regular-message.bot"]["box-shadow"] = shadow;
    window.customStyle[".BorderBubble"]["box-shadow"] = shadow;
    window.customStyle[".MessengerText"]["box-shadow"] = shadow;
    window.customStyle[".webchat-typing-indicator"]["box-shadow"] = shadow;
    window.styleElement.textContent = window.css.of(window.customStyle);
})